import { render, staticRenderFns } from "./AssignmentEditor.vue?vue&type=template&id=19110846&scoped=true&"
import script from "./AssignmentEditor.vue?vue&type=script&lang=js&"
export * from "./AssignmentEditor.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentEditor.vue?vue&type=style&index=0&id=19110846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19110846",
  null
  
)

export default component.exports